import { WindowType } from '../../types/global-window-type';
import { IUserInfo } from '../api-utils/user-profile-api';
import { enableEnhancedPreChat, isStudioPage } from '../app-utils/page-specific-utils';
import { getNRId, logNR } from '../app-utils/nr-logging';
import { getChatConfig } from '../app-utils/chat-config-utils';
import { IAddionalProperties } from '../../types/app-interfaces';

declare const window: WindowType;

export const initChat = () => {
  const { sfConfig } = getChatConfig();
  window.embeddedservice_bootstrap.init(sfConfig.orgId, sfConfig.eswConfigDevName, sfConfig.siteURL, {
    scrt2URL: sfConfig.scrt2URL,
  });
};

const fetchBrowserName = () => {
  const browserInfo = navigator.userAgent;
  let browserName: string;
  if (browserInfo.includes('Opera') || browserInfo.includes('Opr')) {
    browserName = 'Opera';
  } else if (browserInfo.includes('Edg')) {
    browserName = 'Edge';
  } else if (browserInfo.includes('Chrome')) {
    browserName = 'Chrome';
  } else if (browserInfo.includes('Safari')) {
    browserName = 'Safari';
  } else if (browserInfo.includes('Firefox')) {
    browserName = 'Firefox';
  } else {
    browserName = 'unknown';
  }
  return browserName;
};

const fetchDeviceType = () => {
  const browserInfo = navigator?.userAgent;
  if (!browserInfo) return 'Unknown';
  if (/Mobi|Android|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(browserInfo)) {
    return 'Mobile';
  }
  if (/iPad|Tablet|PlayBook|Silk/i.test(browserInfo)) {
    return 'Tablet';
  }
  return 'Desktop';
};

export const setHiddenPrechatFields = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  contextData: any,
  userInfo?: IUserInfo,
  additionalProperties?: IAddionalProperties,
) => {
  const fieldList = [
    'chatLocale',
    'brand',
    'priority',
    'pageName',
    'pageURL',
    'category',
    'subCategory',
    'caseOrigin',
    'subject',
    'description',
    'status',
    'banner',
    'pageSection',
    'pageStage',
    'pagePath',
    'queueId',
    'localeLanguage',
  ];

  let hiddenFields = {};
  const isEnhancedEnable = enableEnhancedPreChat();
  // const isEnhancedEnable = false;
  Object.entries(contextData).forEach(([key, val]) => {
    const fieldValue = val as { label: string; value: string };
    if (fieldList.includes(key)) {
      if (isEnhancedEnable && (key === 'category' || key === 'subCategory' || key === 'subject')) {
        return;
      }
      hiddenFields[key] = fieldValue?.value?.slice(0, 200);
    }
  });

  const gaID = window.localStorage.getItem('ajs_anonymous_id');
  const gaAnonymousId = gaID ? JSON.parse(gaID?.slice(0, 200)) : null;

  //* By default, set the default queueID */
  let queueId = getChatConfig().sfConfig?.queueInfo?.default;
  if (additionalProperties?.sfConfig) {
    /** If custom queue is specified, update the queue */
    const queuetype = additionalProperties.sfConfig;
    const updatedQueueId = getChatConfig().sfConfig?.queueInfo[queuetype];
    console.info('Queue Type:', { queuetype, updatedQueueId });
    if (updatedQueueId) queueId = updatedQueueId;
    console.info('Updated Queue ID:', { queueId });
  }
  hiddenFields = {
    ...hiddenFields,
    nrLogKey: getNRId(),
    isLoggedIn: (!!userInfo?.email).toString(),
    gaAnonymousId,
    referrerURL: document?.referrer?.slice(0, 200),
    BrowserName: fetchBrowserName(),
    BrowserLanguage: navigator.language,
    BrowserPlatform: navigator.platform,
    device_type: fetchDeviceType(),
  };

  /** Send QueueId only for non enhanched pre-chat */
  if (!enableEnhancedPreChat()) {
    hiddenFields = { ...hiddenFields, queueId };
  }
  console.info('Setting Hidden Fields', { hiddenFields });

  window.embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields(hiddenFields);
};

export const setAdditionalInfo = (userInfo?: IUserInfo) => {
  if (userInfo) {
    const userData = {
      isLoggedIn: !!userInfo,
      firstName: userInfo?.firstName,
      lastName: userInfo?.lastName,
      email: userInfo?.email,
      userToken: userInfo?.userToken,
    };
    if (!userData?.email) {
      logNR('CA_USER_EMAIL_EMPTY');
      console.warn('CASELINKING CA_USER_EMAIL_EMPTY');
    }
    if (!userData?.lastName && userData?.email) {
      userData.lastName = userData?.firstName || userData?.email;
      if (userData?.firstName) {
        logNR('CA_USER_LASTNAME_EMPTY_UPDATED_WITH_FIRSTNAME');
        console.warn('CASELINKING CA_USER_LASTNAME_EMPTY_UPDATED_WITH_FIRSTNAME');
      } else if (userData?.email) {
        logNR('CA_USER_LASTNAME_EMPTY_UPDATED_WITH_EMAILID');
        console.warn('CASELINKING CA_USER_LASTNAME_EMPTY_UPDATED_WITH_EMAILID');
      }
    }
    if (!userData?.firstName && userData?.email) {
      userData.firstName = userData?.email;
      logNR('CA_USER_FIRSTNAME_EMPTY_UPDATED_WITH_EMAILID');
      console.warn('CASELINKING CA_USER_FIRSTNAME_EMPTY_UPDATED_WITH_EMAILID');
    }
    console.info('Setting Logged In Info:', { userData });
    window.embeddedservice_bootstrap.settings.embeddedServiceConfig.termsAndConditions.userInfo = userData;
    if (userData?.isLoggedIn && !userData?.firstName) {
      logNR('CA_USER_FIRSTNAME_EMPTY');
    }
    if (userData?.isLoggedIn && !userData?.lastName) {
      logNR('CA_USER_LASTNAME_EMPTY');
    }
  }

  if (enableEnhancedPreChat()) {
    const {
      sfConfig: { queueInfo },
    } = getChatConfig();
    window.embeddedservice_bootstrap.settings.embeddedServiceConfig.termsAndConditions.isEnhancedPreChatPage = true;
    window.embeddedservice_bootstrap.settings.embeddedServiceConfig.termsAndConditions.enhancedQueueMapping = {
      ...queueInfo,
    };
  }
  // send User Website host name
  window.embeddedservice_bootstrap.settings.embeddedServiceConfig.termsAndConditions.host = window.location.host;
  window.embeddedservice_bootstrap.settings.embeddedServiceConfig.termsAndConditions.isStudio = isStudioPage();
};
